<template>
    <div>
        <div class="mb-3">
            <div v-if="selected_check_details" class="d-flex flex-row">
                <h5 class="">Possible answers for:</h5>
                <h5 class="font-weight-light ml-2 ">{{ selected_check_details.prompt }}</h5>
            </div>
            <b-button @click="handleModal()" variant="primary" type="button" class="btn btn-primary mt-1" size="sm">
                <i class="mdi mdi-plus mr-1"> </i> Create
            </b-button>
        </div>
        <webix-ui :config="ui" v-model="options_per_check"></webix-ui>
        <div id="optionsTablePaging"></div>
    </div>
</template>

<script>
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";
//eslint-disable-next-line

export default {
    data: () => ({
        hasMounted: false,
        affidavit_data: [
            { id: "1", type: "Affidavits", start_date: "1 Jan 2022", end_date: "30 Aug 2022" },
            { id: "2", type: "Affidavits", start_date: "1 Sep 2022", end_date: "current" },
            { id: "3", type: "Certificates", start_date: "1 Jan 2022", end_date: "current" },
        ],
    }),
    computed: {
        ...certificateValidationComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "optionsTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "optionsTableHoverRow",
                minHeight: 50,
                minColumnWidth: 120,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                // select: true,
                editable: true,
                pager: {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "optionsTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                },
                columns: [
                    // TODO: Delete
                    // {
                    //     id: "type",
                    //     header: ["Type"],
                    //     tooltip: false,
                    // },
                    {
                        id: "value",
                        header: ["Possible Answers"],
                        tooltip: false,
                        fillspace: 1,
                    },
                ],
                ready() {},
                on: {
                    onBeforeSelect(id) {
                        //eslint-disable-next-line
                        let item = this.getItem(id);
                        //eslint-disable-next-line
                        let el = this.$scope.$parent;
                        //eslint-disable-next-line
                        console.log("I was clciked options", item);

                        // el.hanldeEmit("value", item);
                        // el.$emit("selectedRegulatioVersion", item);
                    },
                    //eslint-disable-next-line
                    // onItemClick: (id, e, node) => {
                    //     //eslint-disable-next-line
                    //     let item = this.getItem(id);
                    //     //eslint-disable-next-line
                    //     console.log("Row clicked:", item);
                    // },
                },
                onChange: {},
                onClick: {},
            };
            //
            return ui;
        },
    },
    methods: {
        ...certificateValidationMethods,
        handleModal() {
            this.$emit("handleModal", "createOptionModal");
        },
    },
    mounted() {
        // this.setCheckOptions({ check_id: 1 });
    },
};
</script>

<style lang="scss">
.optionsTableHoverRow {
    background: #f0dcb6;
    cursor: pointer;
}
</style>
